import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { PermissionGuard } from "@/components/shared/guards/permission-guard";
import { EvaluatorCreateRoutePage } from "@/features/evaluator-operations/registry/route/evaluator-create-route-page";
import { EVALUATOR_DETAIL_VIEW_VALUES } from "@/features/evaluator-operations/types";

export const Route = createFileRoute("/evaluators/new")({
  validateSearch: z.object({
    view: z.enum(EVALUATOR_DETAIL_VIEW_VALUES).catch("overview"),
  }),
  component: () => (
    <PermissionGuard module="evaluators">
      <EvaluatorCreateRoutePage />
    </PermissionGuard>
  ),
});
